import { defineStore } from 'pinia';

export default defineStore('dialogs', {
  state: () => ({
    dialogs: [],
    id: 0,
  }),
  getters: {
    messageDialogs(state) {
      return state.dialogs.filter((item) => item.intent === 'message');
    },
    confirmDialogs(state) {
      return state.dialogs.filter((item) => item.intent === 'confirm');
    },
  },
  actions: {
    addDialog(payload) {
      this.dialogs.unshift({ id: this.id, ...payload });
      this.id += 1;
    },
    removeDialog(id) {
      this.dialogs = this.dialogs.filter((item) => item.id !== id);
    },
  },
});
